// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sk-select__avatar[data-v-09ea8266] {\n  width: 30px;\n  min-width: 25px;\n  height: 30px;\n}\n.sk-select__list-item-wrapper[data-v-09ea8266] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: auto;\n  padding: 7px 8px;\n}\n.sk-select__item-text[data-v-09ea8266] {\n  padding-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
